var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPencil = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2349 3.77278C15.6269 3.38367 16.26 3.38596 16.6492 3.77789L21.581 8.7455C21.9701 9.13743 21.9678 9.77059 21.5759 10.1597L19.4469 12.2733L18.0378 10.854L18.7475 10.1495C19.1394 9.76037 19.1417 9.12721 18.7526 8.73527L16.6389 6.6063C16.2498 6.21437 15.6167 6.21208 15.2247 6.60119L6.91236 14.8537C6.77936 14.9857 6.68614 15.1525 6.64334 15.335L5.99698 18.0904C5.82821 18.8098 6.47122 19.4575 7.19189 19.2939L9.95188 18.6675C10.1347 18.626 10.3021 18.534 10.4351 18.402L18.0378 10.854L19.4469 12.2733L11.8169 19.8484C11.7012 19.9633 11.5591 20.0481 11.403 20.0955L4.24546 22.2696C3.47734 22.5029 2.76127 21.7816 3.00013 21.0152L5.22584 13.8736C5.27437 13.7178 5.36025 13.5764 5.476 13.4614L15.2349 3.77278Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPencil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pencil.39328342.svg";
export { ForwardRef as ReactComponent };